import React, { Component } from 'react';
import {
  HorizontalHeader,
  HorizontalHeaderNav,
  HorizontalHeaderNavItem
} from '@emorg-prd/react-standard';
import './index.css';

export default class Header extends Component {
  render() {
    return (
      <HorizontalHeader
        title={
          <a href='/' style={{ color: 'white' }}>
            Location Data Management {process.env.REACT_APP_TEST_NAME}
          </a>
        }
        variant='condensed'
        color='main'
      >
        <HorizontalHeaderNav>
          <a href='/'>
            <HorizontalHeaderNavItem active>Home</HorizontalHeaderNavItem>
          </a>
          <HorizontalHeaderNavItem>About</HorizontalHeaderNavItem>
        </HorizontalHeaderNav>
      </HorizontalHeader>
    );
  }
}
